(function ($) {
    'use_strict';

    /**
     * Search stores
     */
    $(document).ready(function () {

        $("body").on("click", '.clickable-row', function() {
            if($(this).data("href") !== undefined)
                window.location = $(this).data("href");
        });


        function toggleClickable() {
            if($(window).outerWidth() < 480) {
                $('#store-search-results').find('tr').addClass('clickable-row');
            } else {
                $('#store-search-results').find('tr').removeClass('clickable-row');
            }
        }

        $(window).bind("resize load", function() {
            toggleClickable();
        });

        

        $("body").find("#store-search").submit(function (event) {
            event.preventDefault();
            event.stopPropagation();

            var form = $(this);
            var searchStr = $('#store-search-input').val();

            $('#store-search-results-wrapper').hide();
            $('.store-search-results-table').hide();

            var loading = $('.store-search-loading');
            var translate = gfex;

            loading.fadeIn();
            
            var post_data = {
                url: translate.ajax_url,
                type: 'POST',
                data: {
                    action: 'store_search',
                    search: searchStr
                },
                success: function (data) {
                    if (typeof data === "object") {
                        
                        if (data.success) {
                            console.log(data);
                            $('#store-search-response-text').html('<h4>' + data.data.message + '</h4>');
                            $('#store-search-results').html(data.data.html);
                            $('.store-search-results-table').show();
                        } else 
                            $('#store-search-response-text').html('<h2>' + data.data.message + '</h2>');
                        loading.hide();
                        toggleClickable();
                        $('#store-search-results-wrapper').fadeIn();
                        
                        //btn.removeClass("btn-kebab-loading");
                        return false;
                    }
                },
                complete: function (data) {

                },
                error: function (data) {
                    
                }
            };

            $.ajax(post_data);

        });
    });

})(jQuery, window);
